import { useState, useEffect, useRef } from "react";
import { getEducationData } from "../../../service/api";
import { uploadEducation } from "../../../service/api";
import { deleteEducation } from "../../../service/api";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

function Education() {
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");
  const [showModal, setShowModal] = useState(false);
  const [btnloading, setBtnLoading] = useState(false);
  const [loading, setLoading] = useState(false);

  const [sessionFrom, setSessionFrom] = useState(null);
  const [sessionTo, setSessionTo] = useState(null);

  const [educations, setEducations] = useState([]);

  useEffect(() => {
    const fetchEducations = async () => {
      try {
        setLoading(true);
        const response = await getEducationData();
        setEducations(response.data);
      } catch (err) {
        console.error("Error fetching educations:", err.message);
      } finally {
        setLoading(false); // stop loader
      }
    };

    fetchEducations();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (sessionTo <= sessionFrom) {
      alert("Session To must be greater than Session From");
      return;
    }
    console.log({ sessionFrom, sessionTo });
    setShowModal(false);
  };

  const handleEducationSubmit = async (e) => {
    e.preventDefault();
    try {
      setBtnLoading(true);

      const form = e.target;
      const data = {
        degree: form.degree.value,
        boardOfUniversity: form.boardOfUniversity.value,
        sessionFrom: form.sessionFrom.value,
        sessionTo: form.sessionTo.value,
        gradeOrPercentage: form.gradeOrPercentage.value,
      };

      const response = await uploadEducation(data);

      toast.success(response.data.message);

      form.reset();
      setSessionFrom(null);
      setSessionTo(null);
      setShowModal(false);

      const updatedList = await getEducationData();
      setEducations(updatedList.data);
    } catch (error) {
      // Check if the error is from the server
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast.error(error.response.data.message);
      } else {
        // Fallback to generic error message
        toast.error(error.message || "Something went wrong");
      }
    } finally {
      setBtnLoading(false);
    }
  };

  const handleDeleteEducation = async (educationId) => {
    try {
      const response = await deleteEducation(educationId);

      toast.success(response.data.message);

      setEducations((prev) => prev.filter((edu) => edu.id !== educationId));
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast.error(error.response.data.message);
      } else {
        toast.error(error.message || "Something went wrong");
      }
    }
  };

  return (
    <div>
      {/* <div className="titlSectionu userpaneltitle text-left position-relative">
        <h2>Education Details</h2>
        <p>Add and manage your academic qualifications</p>
      </div> */}

      <button className="normalbtn mb-3" onClick={() => setShowModal(true)}>
        <i className="fa-solid fa-plus"></i> Add Education
      </button>

      {/* Modal */}
      {showModal && (
        <div className="modal fade show d-block" tabIndex="-1">
          <div className="modal-dialog modal-md">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add Education Details</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>

              <div className="modal-body">
                <form onSubmit={handleEducationSubmit}>
                  <div className="row hj-form">
                    <div className="col-md-6">
                      <div className="form-group mb-3">
                        <label htmlFor="degree">
                          Degree / Certification{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="degree"
                          placeholder="Enter Degree / Certificate"
                          required=""
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group mb-3">
                        <label htmlFor="degree">
                          Board / Univercity / Institute{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="boardOfUniversity"
                          placeholder="Enter Board / Institute"
                          required=""
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group mb-3">
                        <label>
                          Session From <span className="text-danger">*</span>
                        </label>
                        <DatePicker
                          selected={sessionFrom}
                          onChange={(date) => {
                            setSessionFrom(date);
                            if (sessionTo && date && sessionTo <= date) {
                              setSessionTo(null);
                            }
                          }}
                          selectsStart
                          name="sessionFrom"
                          startDate={sessionFrom}
                          endDate={sessionTo}
                          dateFormat="dd/MM/yyyy"
                          className="form-control"
                          placeholderText="Select start date"
                          required
                          showYearDropdown
                          showMonthDropdown
                          dropdownMode="select"
                          autoComplete="off"
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group mb-3">
                        <label>
                          Session To <span className="text-danger">*</span>
                        </label>
                        <DatePicker
                          selected={sessionTo}
                          onChange={(date) => setSessionTo(date)}
                          selectsEnd
                          startDate={sessionFrom}
                          endDate={sessionTo}
                          minDate={
                            sessionFrom
                              ? new Date(sessionFrom.getTime() + 86400000)
                              : null
                          }
                          dateFormat="dd/MM/yyyy"
                          className="form-control"
                          placeholderText="Select end date"
                          name="sessionTo"
                          required
                          showYearDropdown
                          showMonthDropdown
                          dropdownMode="select"
                          autoComplete="off"
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group mb-3">
                        <label htmlFor="degree">
                          Grade / Percentage{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="gradeOrPercentage"
                          placeholder="Enter Grade / %"
                          required=""
                        />
                      </div>
                    </div>

                    <div className="col-md-12">
                      <button
                        type="submit"
                        className="mt-4 normalbtn"
                        disabled={btnloading}
                      >
                        {btnloading ? (
                          <span>
                            <i
                              className="fa fa-spinner fa-spin"
                              style={{ marginRight: "8px" }}
                            ></i>
                            Submitting...
                          </span>
                        ) : (
                          "Submit"
                        )}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal Background */}
      {showModal && <div className="modal-backdrop fade show"></div>}

      <div className="row">
        {loading ? (
          <div className="text-center w-100 my-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : educations.length === 0 ? (
          <p className="text-center w-100">No education data found.</p>
        ) : (
          educations.map((edu) => (
            <div key={edu.id} className="col-12 col-md-6 col-lg-4 mb-4">
              <div className="profile-card">
                <h5 className="card-title">{edu.degree}</h5>
                <h6 className="card-subtitle">{edu.boardOfUniversity}</h6>
                <hr />
                <p>Grade / Percentage - {edu.gradeOrPercentage}</p>
                <p>
                  Session ({edu.sessionFrom} to {edu.sessionTo})
                </p>

                <div className="profile-btn">
                  <button
                    className="delete-btn"
                    type="button"
                    onClick={() => {
                      Swal.fire({
                        title: "Are you sure?",
                        text: "You won't be able to revert this!",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#d33",
                        cancelButtonColor: "#3085d6",
                        confirmButtonText: "Yes, delete it!",
                        cancelButtonText: "Cancel",
                      }).then((result) => {
                        if (result.isConfirmed) {
                          handleDeleteEducation(edu.id);
                        }
                      });
                    }}
                  >
                    <i className="fa fa-trash"></i>
                  </button>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default Education;
